// extracted by mini-css-extract-plugin
export default {"paginationBox":"v2style_paginationBox__CaKdh","paginationBox_v2":"v2style_paginationBox_v2__qLRh2","on":"v2style_on__iseAi"};